import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  display: flex;\n  justify-content: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { multiply } from '@atlaskit/theme/math';

/**
 * Provide a styled container for form headers.
 */
export var FormFooterWrapper = styled.footer(_templateObject(), multiply(gridSize, 3), function (props) {
  return props.align === 'start' ? 'flex-start' : 'flex-end';
});